import { isLegacyConnected } from '@/platform/utils/legacy-connector';

const legacyStore = window?.parent?.app?.hybrid?.store;

export default function useCheckout() {
  async function getCheckoutURL(path) {
    if (!isLegacyConnected() || !legacyStore) {
      return null;
    }

    await legacyStore.dispatch('checkout/computeUrl');

    return legacyStore.getters['checkout/checkoutUrl']({
      part: `${path.replace(/^\//g, '')}#ref=`,
    });
  }

  async function navigateToCheckout(path) {
    const url = await getCheckoutURL(path);

    if (!url) {
      return;
    }

    window.parent.document.location.href = url;
  }

  return {
    getCheckoutURL,
    navigateToCheckout,
  };
}
